import { FC } from 'react';
import { FieldError, UseFormRegister } from 'react-hook-form';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';
import { StatusFormBase } from '../../FormBases';

type Props = {
  error: FieldError | undefined;
  register: UseFormRegister<CustomerFormFields>;
  watchStatus: boolean;
};

/**
 * 編集モーダル用の顧客ステータスのコントローラーです
 */
export const StatusForm: FC<Props> = ({ register, error, watchStatus }) => (
  <FormControl isRequired isInvalid={Boolean(error)}>
    <SimpleGrid templateColumns="1fr 2fr">
      <FormLabel>顧客ステータス</FormLabel>
      <HStack spacing={2}>
        <StatusFormBase register={register} value={watchStatus} />
        <Text>{watchStatus ? '契約中' : '解約済み'}</Text>
      </HStack>
      <FormErrorMessage>{error && error.message}</FormErrorMessage>
    </SimpleGrid>
  </FormControl>
);
